import {
  Component,
  ElementRef,
  EventEmitter, Inject,
  Input,
  OnDestroy,
  OnInit,
  Output, PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import {PAGES_AND_PATHS} from '../../constants/pages-and-paths';
import {isPlatformBrowser, Location} from '@angular/common';
import {AuthenticationHelperService} from '../../services/helpers/authentication-helper.service';
import {UiHelperService} from '../../services/helpers/ui-helper.service';
import {Router} from '@angular/router';
import {fadeInFadeOut} from '../../animations/fade-in-out-animation';
import {WebsocketsHelperService} from '../../services/helpers/websockets-helper.service';
import {Subscription} from 'rxjs';
import {NotificationsHttpService} from '../../services/http-services/notifications/notifications-http.service';

@Component({
  selector: 'tl-header',
  templateUrl: './header.component.html',
  animations: [fadeInFadeOut]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() isEditProfile = false;
  @Output() clickOnBackArrow: EventEmitter<void> = new EventEmitter<void>();
  isDropdownOpened = false;
  isNotificationsShow = false;
  notificationsReceivedSubscription: Subscription | undefined;
  hasUnreadNotifications = false;
  @ViewChild('dropdownBtn') dropdownBtn: ElementRef | undefined;
  @ViewChild('notificationBtn') notificationBtn: ElementRef | undefined;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  url = '';

  constructor(private location: Location,
              private renderer: Renderer2,
              private uiHelperService: UiHelperService,
              private authHelperService: AuthenticationHelperService,
              private websocketsHelperService: WebsocketsHelperService,
              private notificationsHttpService: NotificationsHttpService,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.url = this.router.url;
      this.listenToClickDropdown();
      this.listenToClickNotifications();
      this.getNotifications();
      if (this.authHelperService.getUserData) {
        this.websocketsHelperService.listenToNotifications(this.authHelperService.getUserData.id);
        this.notificationsReceivedSubscription = this.websocketsHelperService.notificationReceivedSubject.subscribe((res: any) => {
          this.hasUnreadNotifications = true;
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.notificationsReceivedSubscription?.unsubscribe();
  }

  getNotifications(): void {
    this.notificationsHttpService.getNotifications({page: 1}).then(res => {
      this.hasUnreadNotifications = res.hasUnreadNotifications;
    });
  }

  listenToClickDropdown(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.uiHelperService.checkIfClickedOutsideOfTheElement(this.dropdownBtn, this.dropdownBtn, e)) {
        setTimeout(() => {
          this.isDropdownOpened = false;
        }, 300);
      }
    });
  }


  listenToClickNotifications(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.uiHelperService.checkIfClickedOutsideOfTheElement(this.notificationBtn, this.notificationBtn, e)) {
        if (this.isNotificationsShow) {
          this.hasUnreadNotifications = false;
          setTimeout(() => {
            this.isNotificationsShow = false;
          }, 300);
        }
      }
    });
  }

  goBack(): void {
    this.isEditProfile ? this.clickOnBackArrow.emit() : this.location.back();
  }

  logout(): void {
    this.authHelperService.clientLogout(PAGES_AND_PATHS.login.pagePath);
  }
}
